import * as svg from "../../../assets/airbnb-logo-solid-circle.svg";

import {iconBuilder} from "./iconBuilder";

export const AirbnbCircleIcon = iconBuilder(svg, "AirbnbCircleIcon", "0 0 1150.9 1150.9");
